import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_ProgramService {

  constructor(private http: HttpClient) { }

  GetRecord(): Observable<Array<PM_Program_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram").pipe(
      map(data => {
        return data as Array<PM_Program_Interface>
      })
    )
  }

  GetActive(): Observable<Array<PM_Program_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram/GetActiveList").pipe(
      map(data => {
        return data as Array<PM_Program_Interface>
      })
    )
  }

  AddEditPM(
    model: PM_Program_Interface,
    Item:Array<number>,
    userId:Array<number>): Observable<PM_Program_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelBody = {
      id: model.id,
      title: model.title,
      duration_id: model.duration_id,

    }

    var body = {
      model: modelBody,
      items : Item,
      userId : userId,
      Token: ''
    }

    return this.http.post(environment.BaseUrl + "Daro/PMProgram/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as PM_Program_Interface
      })
    )

  }




  DeletePM(id: number): Observable<PM_Program_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/PMProgram/Delete?id=" + id ).pipe(
      map(data => {
        return data as PM_Program_Interface
      })
    )

  }


  GetUser(id: number): Observable<Array<User_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMProgram/GetUser?id=" + id ).pipe(
      map(data => {
        return data as Array<User_Interface>
      })
    )
  }


}
